/*
 * @Author: mayanxia 
 * @Date: 2020-12-29 11:43:57 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-04 16:31:43
 */
/* 运营分析 */
<template>
    <div class="index-main">
        <a-row style="height: 100%;positive: relative">
            <a-col :span="6" class="cell-left">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 33.33%">
                      <WaterSupplyMonitoring ref="WaterSupplyMonitoringRef" :titleImage="titleImage" />
                      
                    </a-col>
                    <a-col :span="24" style="height: 33.33%">
                        <KeyAreasAndAbnormalPressure ref="KeyAreasAndAbnormalPressureRef" :titleImage="titleImage" />
                        <!-- <water-quality-sensor-analysis ref="waterQualitySensor" :titleImage="titleImage"></water-quality-sensor-analysis> -->
                    </a-col>
                    <a-col :span="24" style="height: 33.33%">
                        <water-qualityAlarmNow-ScrollList ref="alarmScrollList" :titleImage="titleImage"></water-qualityAlarmNow-ScrollList>
                        <!-- <water-quality-index-diff-analysis ref="waterQualityIndexDiff" :titleImage="titleImage"></water-quality-index-diff-analysis> -->
                    </a-col>
                    
                </a-row>
            </a-col>
            <a-col :span="12" style="height: 100%;">
                <a-row style="height: 70%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 100%;position: relative">
                        <div style="position: absolute;top: 0;left: 80px;z-index: 99">
                            <water-quality-total ref="waterQualityTotal"></water-quality-total>
                        </div>
                        <!-- <echart-map :titleImage="titleImage"></echart-map> -->
                        <waterQualityCenter></waterQualityCenter>
                    </a-col>
                </a-row>
                <a-row  class="cell-bottom" style="height: 30%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 100%">
                      <RealTimeDataOfPumpRoom ref="RealTimeDataOfPumpRoomRef" />
                        <!-- <water-qualityIndex-line-analysis ref="waterQualityIndexLine" :titleImage="titleImage"></water-qualityIndex-line-analysis> -->
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="6" class="cell-right">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 33%">
                      <video-monitoring :titleImage="titleImage"></video-monitoring>
                        <!-- <water-device-info ref="waterDevice" :titleImage="titleImage"></water-device-info> -->
                    </a-col>
                    <a-col :span="24" style="height: 33%">
                      <water-qualityIndex-line-analysis ref="waterQualityIndexLine" :titleImage="titleImage"></water-qualityIndex-line-analysis>
                        <!-- <water-quality-index-diff-analysis ref="waterQualityIndexDiff" :titleImage="titleImage"></water-quality-index-diff-analysis> -->
                        <!-- <press-device-info ref="pressDevice" :titleImage="titleImage"></press-device-info> -->
                        <!--<water-qualityIndex-diff-analysis :titleImage="titleImage"></water-qualityIndex-diff-analysis>-->
                    </a-col>
                    <a-col :span="24" style="height: 34%">
                      <WaterQualityQualificationRate ref="WaterQualityQualificationRateRef" :titleImage="titleImage"></WaterQualityQualificationRate>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import waterQualitySensorAnalysis from './modules/waterQualitySensorAnalysis'
import videoMonitoring from './modules/videoMonitoring'
import waterQualityIndexLineAnalysis from './modules/waterQualityIndexLineAnalysis'
import waterQualityIndexDiffAnalysis from './modules/waterQualityIndexDiffAnalysis'
import waterQualityAlarmNowScrollList from './modules/waterQualityAlarmNowScrollList'
import echartMap from './modules/echartMap'
import waterQualityTotal from './modules/waterQualityTotal'
import waterDeviceInfo from './modules/waterDeviceInfo.vue'
import pressDeviceInfo from './modules/pressDeviceInfo.vue'
import waterQualityCenter from './modules/waterQualityCenter'
import WaterQualityQualificationRate from './modules/WaterQualityQualificationRate'
import WaterSupplyMonitoring from './modules/WaterSupplyMonitoring'
import KeyAreasAndAbnormalPressure from './modules/KeyAreasAndAbnormalPressure'
import RealTimeDataOfPumpRoom from './modules/RealTimeDataOfPumpRoom'
export default {
    components: {
        waterQualityIndexDiffAnalysis,
        waterQualitySensorAnalysis,
        videoMonitoring,
        waterQualityIndexLineAnalysis,
        waterQualityAlarmNowScrollList,
        echartMap,
        waterQualityTotal,
        waterDeviceInfo,
        pressDeviceInfo,
        waterQualityCenter,
        WaterQualityQualificationRate,
        WaterSupplyMonitoring,
        KeyAreasAndAbnormalPressure,
        RealTimeDataOfPumpRoom
    },
    data() {
        return {
            titleImage:require("@/assets/images/title-gradual.png"),
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.init()
        })
    },
    methods: {
        init() {
            // this.$refs.waterQualityIndexDiff.init()
            // this.$refs.waterQualitySensor.init()
            // this.$refs.waterDevice.init()
            // this.$refs.pressDevice.init()
            this.$refs.waterQualityIndexLine.init()
            this.$refs.alarmScrollList.init()
            this.$refs.waterQualityTotal.init()

            this.$refs.WaterQualityQualificationRateRef.init()
            this.$refs.WaterSupplyMonitoringRef.init();
            this.$refs.KeyAreasAndAbnormalPressureRef.init();
        }
    }
}
</script>
<style lang="less" scoped>
.index-main{
    height: 100%;
    padding: 12px;
}
.cell-left,.cell-right,.cell-bottom{
    height: 100%;
    //position: absolute;
    padding-left: 12px;
    padding-right: 12px;
}
.cell-left{
    top: 0;
    left: 0;
}
.cell-right{
    top: 0;
    right: 0;
}
.cell-bottom{
    height: 30%;
    //position: absolute;
    background: url('~@/assets/images/cell-bottom.png') no-repeat;
    background-size: 100% 100%;
    margin-left: 5px;
    margin-right: 5px;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #ffffff;
        height: 100%;
    }
    /deep/ .m-panel-bar{
        height: 40px;
    }
    /deep/ .m-panel-bar-title{
        font-size: 18px;
        font-weight: 700;
        color: #B6DEFF;
        display: flex;
        align-items: center;
        padding-left: 7px;
        border-bottom: 5px solid transparent; /* 创建透明的下边框 */
        border-image: url('~@/assets/images/title-gradual.png') 5 stretch; /* 指定图像路径、重复次数和对齐方式 */
        border-image-repeat: stretch;
    }
    /deep/ .m-panel-body{
        height: calc(100% - 40px)
    }
    /deep/ .total-sum{
        color: #6ED9F2;
        font-weight: bold;
        font-size: 30px;
    }
    /deep/ .unit{
        font-size: 12px;
        color: #CEE2FF;
        margin-left: 5px;
    }
    /deep/ .m-total{
        padding: 10px;
        line-height: 1;
        background-image: linear-gradient(270deg, #07132C 0%, #0D1A34 32%, #0E2250 99%);
        .total-title{
            color: #CEE2FF;
        }
    }
    /deep/ .font-24{
        font-size: 24px;
    }
    /deep/ .flex-center{
        display: flex;
        align-items: center;
    }
}
.cell-left{
    position: relative;
    background: url('~@/assets/images/cell-left.png') no-repeat;
    background-size: 100% 100%;
}
.cell-right{
    position: relative;
    background: url('~@/assets/images/cell-right.png') no-repeat;
    background-size: 100% 100%;
}
</style>